export const imgUrl = "https://www.truwa.in/static/images/";
export const lottieUrl = "https://www.truwa.in/static/images/Lottie/";

export const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};
